var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134.304,
    height: 122.147,
    viewBox: "0 0 134.304 122.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,122.442H60.678V0H0Z",
    fill: "none",
    stroke: "#ffb511",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.517 122.147) rotate(-127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.217 1.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.977,120.17C51.319,119.674-13.677,69.616,2.621,0L4.338.332C-11.743,69,52.445,118.462,53.1,118.956Z",
    fill: "#fda634",
    stroke: "#ffb511",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.217 1.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.977,120.17C51.319,119.674-13.677,69.616,2.621,0L4.338.332C-11.743,69,52.445,118.462,53.1,118.956Z",
    fill: "none",
    stroke: "#ffb511",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.26 0.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.838,13.828a.906.906,0,0,1-1.144-.422L10.476,2.247l-8.955,9a.941.941,0,0,1-1.235.061.748.748,0,0,1-.063-1.121L10.1.261a.933.933,0,0,1,.794-.25.875.875,0,0,1,.66.471L17.3,12.789a.732.732,0,0,1,.057.441.813.813,0,0,1-.522.6",
    fill: "#fda634",
    stroke: "#ffb511",
    strokeWidth: 0.229
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.26 0.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.838,13.828a.906.906,0,0,1-1.144-.422L10.476,2.247l-8.955,9a.941.941,0,0,1-1.235.061.748.748,0,0,1-.063-1.121L10.1.261a.933.933,0,0,1,.794-.25.875.875,0,0,1,.66.471L17.3,12.789a.732.732,0,0,1,.057.441A.813.813,0,0,1,16.838,13.828Z",
    fill: "none",
    stroke: "#ffb511",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrange);
export default __webpack_public_path__ + "static/media/arrow-orange.8a2d91dd725cc68acb21d9cd1b9b10f9.svg";
export { ForwardRef as ReactComponent };